module.exports = __webpack_public_path__ + "static/cafe02-ce747b30899036a46b379ba4ab218764.jpg";